"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyScoreProof = exports.getScoreProof = void 0;
var bignumber_1 = require("@ethersproject/bignumber");
var ethers_1 = require("ethers");
function getScoreProof(creditScore, creditScoreTreeToCheck) {
    return {
        account: creditScore.account,
        score: creditScore.amount,
        merkleProof: creditScoreTreeToCheck.getProof(creditScore.account, creditScore.amount),
    };
}
exports.getScoreProof = getScoreProof;
function getEmptyScoreProof(account) {
    return {
        account: account || ethers_1.constants.AddressZero,
        score: bignumber_1.BigNumber.from(0),
        merkleProof: [],
    };
}
exports.getEmptyScoreProof = getEmptyScoreProof;
//# sourceMappingURL=getScoreProof.js.map